import { render, staticRenderFns } from "./ProInclusion.vue?vue&type=template&id=3900c9d4&scoped=true"
import script from "./ProInclusion.ts?vue&type=script&lang=ts&external"
export * from "./ProInclusion.ts?vue&type=script&lang=ts&external"
import style0 from "./ProInclusion.scss?vue&type=style&index=0&id=3900c9d4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3900c9d4",
  null
  
)

export default component.exports